<template>
  <section class="topic-carousel">
    <Swiper :modules="swiperModules" :pagination="{ clickable: true }">
      <SwiperSlide v-for="item in carouselList" :key="item.id">
        <a :href="item.url" class="topic-carousel-a">
          <img
            :src="item.image"
            class="topic-carousel-image"
            :alt="item.title"
          />
          <div class="topic-carousel-title">{{ item.title }}</div>
        </a>
      </SwiperSlide>
    </Swiper>
  </section>
</template>

<script setup lang="ts">
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const swiperModules = [Pagination, Autoplay];
export interface CarouselNews {
  image: string;
  title: string;
  url: string;
  id: string;
}
defineProps({
  carouselList: {
    type: Array as () => CarouselNews[],
    required: true,
  },
});
</script>

<style lang="scss" scoped>
.topic-carousel {
  .topic-carousel-a {
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
  }

  .topic-carousel-image {
    width: 100%;
  }

  .topic-carousel-title {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 35px;
    padding: 0 5px;
    overflow: hidden;
    line-height: 35px;
    color: #fff;
    text-decoration: none;
    text-overflow: ellipsis;
    white-space: nowrap;
    background: rgb(0 0 0 / 30%);
  }

  :deep(.swiper-pagination) {
    position: relative;
    margin-top: 3px;

    .swiper-pagination-bullet {
      width: 6px;
      height: 6px;
      background-color: #e12d49;
    }

    .swiper-pagination-bullet-active {
      background-color: #ceeaff;
    }
  }
}
</style>
